////
/// ============================================================================
/// COMPONENT / Shop Sidebar
/// ============================================================================
///
/// @group components
////

/**
 * @todo https://jsfiddle.net/gebpjo1L/18/
 */

export default () => {
    jQuery(document).ready(function ($) {

        /**
         * WooCommerce Product Category Accordion jQuery Menu
         * @link https://wpbeaches.com/woocommerce-accordion-style-expand-collapse-product-category-menu/
         */

        if ($('ul.product-categories').length > 0) {
            var parentCat = $('.product-categories li.cat-parent');
            var firstParentCat = $('.product-categories li.cat-parent:first-child'); // Start this one open
            var currentCat = $('.product-categories li.current-cat');
            var currentCatParent = $('.product-categories li.current-cat-parent');

            $('.product-categories li.cat-parent > a').wrap('<div class="cat-item_wrap"></div>').after('<span class="cat-item_toggle"></span>');

            parentCat.parent('ul').addClass('has-toggle');
            parentCat.children('ul').hide();

            if (parentCat.hasClass("current-cat-parent")) {
                currentCatParent.addClass('is-open');
                currentCatParent.children('ul').show();
            } else if (parentCat.hasClass("current-cat")) {
                currentCat.addClass('is-open');
                currentCat.children('ul').show();
            } else {
                firstParentCat.addClass('is-open');
                firstParentCat.children('ul').show();
            }

            $('.has-toggle .cat-item_toggle').on('click', function () {
                $t = $(this);
                if ($t.parent().parent().hasClass("is-open")) {
                    $t.parent().parent().removeClass('is-open');
                    $t.parent().parent().children('ul').slideUp();
                } else {
                    $t.parent().parent().parent().find('.children').slideUp();
                    $t.parent().parent().parent().find('li.cat-parent').removeClass('is-open');

                    $t.parent().parent().addClass('is-open');
                    $t.parent().parent().children('ul').slideDown();
                }

            });

            // Link the count number
            $('.count').css('cursor', 'pointer');
            $('.count').on('click', function (event) {
                $(this).prev('a')[0].click();
            });
        }

    });
}